<template>
    <section>
        <div class="forgotPassFormWrapper">
            <div class="forgotPassForm d-flex justify-space-around align-center">
                <v-card
                    v-if="!isTknExists.status"
                    class="elevation-5 forgotPassCard"
                    shaped
                >
                    <div class="forgotPass">
                        <img src="./../../assets/forgotPass.svg" alt="">
                    </div>
                    <v-card-title>Forgot password? </v-card-title>
                    <v-card-text>
                        <v-alert
                            v-model="notif.show"
                            dismissible
                            class="text-center"
                            transition="scale-transition"
                            style="position: absolute; z-index: 2; left: 0; right: 0; top: calc(20% - 10px); margin: 0 10px; border-radius: 16px;"
                            :color="notif.type"
                            :type="notif.type"
                        >
                            {{ notif.msg }}
                        </v-alert>
                        <div class="txtFieldWrapper" style="position: relative;">
                            <v-form
                                ref="form"
                                v-model="valid"
                                @submit.prevent="validateForm()"
                            >
                                <v-text-field
                                    v-model="email"
                                    :disabled="disableForgotBtn"
                                    clearable
                                    :rules="emailRules"
                                    label="Enter your email"
                                    color="green accent-4"
                                    autocomplete="nope"
                                />
                                <v-btn
                                    type="submit"
                                    :disabled="!valid || disableForgotBtn"
                                    small
                                    color="green accent-4 white--text"
                                    class="my-3"
                                >
                                    {{ btnText }}
                                </v-btn>
                            </v-form>
                        </div>
                    </v-card-text>
                </v-card>
                <v-card
                    v-else
                    class="elevation-5 forgotPassCard"
                    haped
                >
                    <div class="forgotPass">
                        <img src="./../../assets/newpassword.svg" alt="">
                    </div>
                    <v-card-title>Reset password</v-card-title>
                    <v-divider />
                    <v-card-text>
                        <v-alert
                            v-model="notif.show"
                            dismissible
                            class="text-center"
                            transition="scale-transition"
                            style="position: absolute; z-index: 2; left: 0; right: 0; top: calc(20% - 10px); margin: 0 10px; border-radius: 16px;"
                            :color="notif.type"
                            :type="notif.type"
                        >
                            {{ notif.msg }}
                        </v-alert>
                        <v-form
                            ref="form"
                            v-model="valid"
                            @submit.prevent="recoverPass()"
                        >
                            <div class="txtfieldWrapper">
                                <v-text-field
                                    v-model="pass.new"
                                    :disabled="disableForgotBtn"
                                    label="Enter your new password"
                                    color="green accent-4"
                                    :rules="passwordRule"
                                    :append-icon="showPass.new ? mdiEye : mdiEyeOff"
                                    :type="showPass.new ? 'text' : 'password'"
                                    @click:append="showPass.new = !showPass.new"
                                />
                                <v-text-field
                                    v-model="pass.retype"
                                    :disabled="disableForgotBtn"
                                    label="Retype your new password"
                                    color="green accent-4"
                                    :rules="retypeRule.concat([pass.new === pass.retype||'Password must match'])"
                                    :append-icon="showPass.retype ? mdiEye : mdiEyeOff"
                                    :type="showPass.retype ? 'text' : 'password'"
                                    @click:append="showPass.retype = !showPass.retype"
                                />
                            </div>
                            <v-btn
                                type="submit"
                                :disabled="!valid || disableForgotBtn"
                                small
                                color="green accent-4 white--text"
                                class="my-3"
                            >
                                Reset
                            </v-btn>
                        </v-form>
                    </v-card-text>
                </v-card>
            </div>
        </div>
    </section>
</template>

<script>
import { mdiEye, mdiEyeOff } from '@mdi/js'
import { mapActions, mapGetters } from 'vuex'
export default {
    data: () => ({
        mdiEye, mdiEyeOff,
        btnText: 'reset',
        disableForgotBtn: false,
        email: null,
        valid: false,
        success: {
            status: false,
            msg: 'Redirecting to login ...'
        },
        notif: {
            msg: '',
            show: false,
            type: null
        },
        isTknExists: {
            status: false,
            value: null
        },
        pass: {
            new: null,
            retype: null
        },
        showPass: {
            new: null,
            retype: null
        },
        emailRules: [
            v => !!v || 'Email is required',
            // v => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v) || "E-mail must be valid",
            v => /^[a-zA-Z0-9]+([._%-][a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/.test(v) || 'E-mail must be valid'
        ],
        passwordRule: [
            (v) => !!v || 'Enter your password',
            (v) =>
                // validate the new regex here https://regexr.com/7rr6e
                // /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/.test(validation) ||
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d!@#$%^&*()-_=+{};:,.<>?/\\|\[\]~]{8,}$/.test(v) ||
                'Must contain uppercase, lowercase and number and at least 8 characters '
        ],
        retypeRule: [v=>!!v||'Retype password is required']
    }),
    computed: {
        ...mapGetters(['forgotPasswordAdminData', 'recoverPasswordAdminData'])
    },
    watch: {
        recoverPasswordAdminData(newVal) {
            if (newVal) {
                if (newVal.status !== 200) {
                    this.notif.type         = 'error'
                    this.notif.msg          = newVal.state
                } else {
                    this.disableForgotBtn   = true
                    this.notif.type         = 'success'
                    this.notif.msg          = 'Password Reset Successfully!'
                    this.timer = 6
                    const intervalId = setInterval(() => {
                        this.timer--
                        this.notif.msg = `Redirecting to login ... (${this.timer})`
                        if (this.timer === 0) {
                            this.disableForgotBtn   = false
                            clearInterval(intervalId)
                            this.$router.push({ name: 'adminLogin' })
                        }
                    }, 1000)
                }
                this.notif.show = true
                setTimeout(()=>{ this.notif.show = false }, 6000)
            }
        },
        forgotPasswordAdminData(newVal) {
            if (newVal) {
                // console.log('forgotPasswordAdminData newVal: ', newVal)
                if (newVal.status !== 200) {
                    this.notif.type         = 'error'
                    this.notif.msg          = newVal.state
                } else {
                    this.disableForgotBtn   = true
                    this.notif.type         = 'success'
                    this.notif.msg          = 'Password Reset Email Sent!'
                    this.timer = 11
                    const intervalId = setInterval(() => {
                        this.btnText = `reset (${this.timer})`
                        this.timer--
                        if (this.timer === 0) {
                            this.btnText = 'reset'
                            this.disableForgotBtn = false
                            clearInterval(intervalId)
                        }
                    }, 1000)
                }
                this.notif.show = true
                setTimeout(()=>{ this.notif.show = false }, 5000)
            }
        }
    },
    created() {
        const tkn = this.$route.query.tkn
        if (tkn !== null && tkn !== undefined) {
            this.isTknExists.status = true
            this.isTknExists.value = tkn
        }
    },
    methods: {
        ...mapActions(['getCsrfToken', 'forgotPasswordAdmin', 'recoverPasswordAdmin']),
        recoverPass() {
            if (this.$refs.form.validate()) {
                this.recoverPasswordAdmin({ TOKEN: this.isTknExists.value, NEW_PASS: this.pass.new })
            }
        },
        validateForm() {
            if (this.$refs.form.validate()) {
                this.forgotPasswordAdmin({ EMAIL: this.email })
            }
        }
    }
}
</script>

<style scoped>
section {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 100%;
  background-image: url("./../../assets/loginBG.webp");
  background-position: center;
  background-size: cover;
}
.forgotPassFormWrapper {
  width: 100%;
}
.displayForgotAccnt {
  display: flex;
  width: 100%;
}
.forgotPassCard {
  background-image: url("./../../assets/mail-bg-wrapper.webp");
  background-size: cover;
  background-position: right;
  width: 30%;
}
.forgotPass {
  width: 50%;
  margin: auto;
}
.forgotPass img {
  width: 100%;
}
.alertNotif {
    position: fixed;
    top: 30px;
    right: 7.5%;
    z-index: 999;
}
@media (max-width: 599px) {
  .forgotPassCard {
    width: 90%;
  }
  .txtfieldWrapper {
    width: 100%;
  }
}
@media (min-width: 599px) and (max-width: 960px) {
  .forgotPassCard {
    width: 40%;
  }
  .txtfieldWrapper {
    width: 100%;
  }
}
@media (min-width: 960px) and (max-width: 1264px) {
  .txtfieldWrapper {
    width: 100%;
  }
}
</style>
